// extracted by mini-css-extract-plugin
module.exports = {"error":"form_error__1GXUB","button":"form_button__HeFLT"};